import { useWindowHeight } from './useWindowHeight';

const PAGE_HEADER_HEIGHT = 80;
const PAGE_FOOTER_HEIGHT = 46;
const MAX_DROPDOWN_HEIGHT = 650;

/**
 * Calculates max height of the dropdown element based on the window height.
 */
export function useDropdownMaxHeight(): number {
    const windowHeight = useWindowHeight();

    const availableSpace = windowHeight - PAGE_HEADER_HEIGHT - PAGE_FOOTER_HEIGHT;
    return Math.min(MAX_DROPDOWN_HEIGHT, availableSpace);
}
